import { Autocomplete, SxProps, TextField, Theme } from "@mui/material";
import { FC, useMemo } from "react";
import { useFirmsByLensId } from "helpers/hooks/useAllowedLenses";

interface Props {
  sxProps?: SxProps<Theme>;
  lensId?: number;
  firmId?: number;
  onChange: (firmId: number | null) => void;
}

const FirmAutocomplete: FC<Props> = ({ firmId, lensId, onChange, sxProps }) => {
  const firms = useFirmsByLensId(lensId);
  const optionFirms = firms.map((f) => ({ label: f.name, value: `${f.id}` }));
  const defaultFirm = useMemo(() => optionFirms.find((o) => o.value === `${firmId}`), [firmId, optionFirms]);

  return (
    <Autocomplete
      sx={sxProps}
      size="small"
      autoHighlight
      autoComplete
      fullWidth
      options={optionFirms}
      value={defaultFirm || { label: "", value: "" }}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      onChange={(_evt, newValue) => onChange(newValue?.value ? parseInt(newValue.value) : null)}
      renderInput={(params) => <TextField {...params} label="Firm" />}
    />
  );
};

export default FirmAutocomplete;
